/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BalanceDto } from '../models/balance-dto';
import { TransactionDto } from '../models/transaction-dto';
import { userControllerConfirmPaymentTransaction } from '../fn/user/user-controller-confirm-payment-transaction';
import { UserControllerConfirmPaymentTransaction$Params } from '../fn/user/user-controller-confirm-payment-transaction';
import { userControllerGetBalance } from '../fn/user/user-controller-get-balance';
import { UserControllerGetBalance$Params } from '../fn/user/user-controller-get-balance';
import { userControllerGetTransactionByUuid } from '../fn/user/user-controller-get-transaction-by-uuid';
import { UserControllerGetTransactionByUuid$Params } from '../fn/user/user-controller-get-transaction-by-uuid';
import { userControllerGetTransactions } from '../fn/user/user-controller-get-transactions';
import { UserControllerGetTransactions$Params } from '../fn/user/user-controller-get-transactions';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userControllerGetBalance()` */
  static readonly UserControllerGetBalancePath = '/user/me/balance';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetBalance()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetBalance$Response(params?: UserControllerGetBalance$Params, context?: HttpContext): Observable<StrictHttpResponse<BalanceDto>> {
    return userControllerGetBalance(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetBalance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetBalance(params?: UserControllerGetBalance$Params, context?: HttpContext): Observable<BalanceDto> {
    return this.userControllerGetBalance$Response(params, context).pipe(
      map((r: StrictHttpResponse<BalanceDto>): BalanceDto => r.body)
    );
  }

  /** Path part for operation `userControllerGetTransactions()` */
  static readonly UserControllerGetTransactionsPath = '/user/me/transaction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetTransactions$Response(params?: UserControllerGetTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TransactionDto>>> {
    return userControllerGetTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetTransactions(params?: UserControllerGetTransactions$Params, context?: HttpContext): Observable<Array<TransactionDto>> {
    return this.userControllerGetTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TransactionDto>>): Array<TransactionDto> => r.body)
    );
  }

  /** Path part for operation `userControllerGetTransactionByUuid()` */
  static readonly UserControllerGetTransactionByUuidPath = '/user/me/transaction/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetTransactionByUuid()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetTransactionByUuid$Response(params: UserControllerGetTransactionByUuid$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionDto>> {
    return userControllerGetTransactionByUuid(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetTransactionByUuid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetTransactionByUuid(params: UserControllerGetTransactionByUuid$Params, context?: HttpContext): Observable<TransactionDto> {
    return this.userControllerGetTransactionByUuid$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionDto>): TransactionDto => r.body)
    );
  }

  /** Path part for operation `userControllerConfirmPaymentTransaction()` */
  static readonly UserControllerConfirmPaymentTransactionPath = '/user/payment/{uuid}/confirm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerConfirmPaymentTransaction()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerConfirmPaymentTransaction$Response(params: UserControllerConfirmPaymentTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionDto>> {
    return userControllerConfirmPaymentTransaction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerConfirmPaymentTransaction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerConfirmPaymentTransaction(params: UserControllerConfirmPaymentTransaction$Params, context?: HttpContext): Observable<TransactionDto> {
    return this.userControllerConfirmPaymentTransaction$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionDto>): TransactionDto => r.body)
    );
  }

}
